const LoginMethod = {
  NONE: 'none',
  EMAIL: 'email',
  SMS: 'sms',
};


module.exports.LoginMethod = LoginMethod;
